<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';

export default {
  mixins: [fandomBasicMixin],
  data: function () {
    return { };
  },
  created() {
    if (this.content.theme) {
      this.content.stripes.forEach((stripe) => {
        if (!Fandom.exists(stripe.theme)) {
          Vue.set(stripe, "theme", this.content.theme);
        }
      });
    }
  },
};
</script>

<template>
  <div 
    v-easyadmin="easyadminId" 
    :class="[contentType, {'secondary-navbar-present': !!content.navbar}, `${this.content.theme}-theme`]" 
    v-if="isContentVisibleToUser()" 
    class="position-relative" 
    page-blank-component
  >
    <component :is="stripe.layout" :content="stripe" v-for="(stripe, index) in content.stripes" :key="stripe.$id" :opt-container-content="containerContent" :class="{'first': !index}"></component>
  </div>
</template>

<style lang="scss">
[page-blank-component] {

  &.secondary-navbar-present {
    .first .mh-100vh-header {
      min-height: calc(100vh - #{$header-height} - #{$auxiliary-navbar-height});
    }

    .first .h-100vh-header {
      height: calc(100vh - #{$header-height} - #{$auxiliary-navbar-height});
    }
  }

}
</style>
